<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div class="content__inner" v-else-if="!loading && !blocks.length">
        <div class="alert alert-danger text-center">
            <h4 class="alert-heading m-0">
                <strong>Whoops!</strong> It looks like you can't see any of this users blocks.
            </h4>
        </div>
    </div>

    <div class="card" v-else>
        <div class="bg-primary align-items-center d-flex">
            <h5 class="card-header text-white">{{ user.name }} Blocks</h5>
            <b-pagination align="right" class="my-auto mr-2 ml-auto" :total-rows="pagination.total" v-model="pagination.page"
                          :per-page="pagination.limit" />
        </div>
        <b-table hover stacked="md" :items="tableData" :fields="blocksTable.fields"
                 :per-page="pagination.limit" :current-page="pagination.page"
                 :show-empty="true">

            <template slot="cropType" slot-scope="row">
                <span v-if="row.item.cropType">{{ row.item.cropType.name }}</span>
                <span class="badge badge-danger" v-else>Removed</span>
            </template>

            <template slot="variety" slot-scope="row">
                <span v-if="row.item.cropType && row.item.variety">{{ row.item.variety.name }}</span>
                <span class="badge badge-danger" v-else-if="row.item.cropType">Removed</span>
                <span class="text-muted" v-else>(none)</span>
            </template>

            <template slot="restrictedEntryInterval" slot-scope="row">
                <strong class="text-danger" v-if="row.item.restrictedEntryInterval">
                    {{ row.item.restrictedEntryInterval.ends_at | date_format }}
                </strong>
                <span class="text-muted" v-else>(none)</span>
            </template>
            <template slot="actions" slot-scope="row">
                <b-button :to="{name: 'spray-diary.create', params: {blockId: row.item.id}}"
                          variant="orange btn--icon" v-b-tooltip="'Update Spray Diary'">
                    <i class="zmdi zmdi-plus"></i>
                </b-button>

                <b-button :to="{name: 'spray-diary.view', params: {blockId: row.item.id}}"
                          variant="success btn--icon" v-b-tooltip="'View spray diary'">
                    <i class="zmdi zmdi-view-list-alt"></i>
                </b-button>

            </template>
        </b-table>
    </div>

</template>

<script>
import listBlocksQuery from '@views/GrowerBlocks/ContractorBrowse/queryListBlocks.graphql';

export default {
  name: 'ContractorGrowerBlocksBrowse',
  props: ['growerId'],
  components: {},
  apollo: {
    blocks: {
      query: listBlocksQuery,
      variables() {
        return {
          input: {
            user_id: this.growerId,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.blocks = data.filterBlocks.data;
          this.pagination.total = data.filterBlocks.meta.total;
        }
      },
    },
  },
  data() {
    return {
      loading: 0,
      blocks: [],
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      blocksTable: {
        fields: [
          { key: 'name', label: 'Block Name', sortable: true },
          { key: 'restrictedEntryInterval', label: 'REI' },
          {
            key: 'cropType',
            label: 'Crop Type',
            sortable: true,
          },
          {
            key: 'variety',
            label: 'Crop Variety',
            sortable: true,
            formatter: variety => variety.name,
          },
          { key: 'actions', label: '', class: 'text-right' },
        ],
      },
    };
  },
  computed: {
    user() {
      return this.$path.get(this.blocks, '0.owner');
    },
    tableData() {
      return (this.blocks || []).map(item => ({
        ...item,
        _cellVariants: {restrictedEntryInterval: item.restrictedEntryInterval ? 'danger' : null},
        // _rowVariant: item.restrictedEntryInterval ? 'danger' : null,
      }));
    },
  },
};
</script>
